export default __webpack_public_path__ + "static/media/check-circle-error.5d570c3a.svg";